import { useEffect, useState } from 'react';

export const useKeyPress = (
	targetKey: string | null,
	targetRef?: HTMLElement,
	options?: {
		stopPropagation?: boolean;
		onChange?: (value: boolean) => unknown;
	}
) => {
	const [keyPressed, setKeyPressed] = useState<boolean>(false);
	const downHandler = (event: KeyboardEvent) => {
		if (event.code !== targetKey) {
			return;
		}
		if (options?.stopPropagation) {
			event.stopPropagation();
			event.preventDefault();
		}
		setKeyPressed(true);
	};
	const upHandler = (event: KeyboardEvent) => {
		if (event.code !== targetKey) {
			return;
		}
		if (options?.stopPropagation) {
			event.stopPropagation();
			event.preventDefault();
		}

		setKeyPressed(false);
	};
	useEffect(() => {
		if (!targetRef) {
			return;
		}
		const ref = targetRef;
		ref.addEventListener('keydown', downHandler);
		ref.addEventListener('keyup', upHandler);
		return () => {
			ref.removeEventListener('keydown', downHandler);
			ref.removeEventListener('keyup', upHandler);
		};
	}, [targetRef]);

	useEffect(() => {
		if (!options?.onChange) {
			return;
		}
		options.onChange(keyPressed);
	}, [keyPressed]);

	return keyPressed;
};
